import { contactInfo } from '@/mocks/homeData';

export default function Contact() {
  return (
    <section id="contact" className="w-full py-12 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-6 text-center">
          {contactInfo.title}
        </h2>
        <div className="max-w-2xl mx-auto bg-background-50 rounded-2xl p-6 md:p-8 border border-background-200/70">
          <p className="text-sm text-foreground-600 leading-relaxed mb-6">
            {contactInfo.desc}
          </p>
          <div className="flex flex-col sm:flex-row gap-4 md:gap-8">
            <a
              href={`mailto:${contactInfo.email}`}
              className="flex items-center gap-3 px-5 py-3 bg-primary-50 hover:bg-primary-100 rounded-xl transition-colors duration-200 group cursor-pointer"
            >
              <span className="w-10 h-10 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-mail-line text-background-50 text-lg"></i>
              </span>
              <div>
                <span className="block text-xs text-foreground-500">电子邮箱</span>
                <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors">{contactInfo.email}</span>
              </div>
            </a>
            <div className="flex items-center gap-3 px-5 py-3 bg-accent-50 rounded-xl">
              <span className="w-10 h-10 flex items-center justify-center bg-accent-500 rounded-lg">
                <i className="ri-wechat-line text-background-50 text-lg"></i>
              </span>
              <div>
                <span className="block text-xs text-foreground-500">微信公众号</span>
                <span className="text-sm font-medium text-foreground-800">{contactInfo.wechat}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}